// API utility functions with base URL configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8787"

export const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`

  const defaultOptions = {
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  }

  const config = { ...defaultOptions, ...options }

  try {
    const response = await fetch(url, config)

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    return await response.json()
  } catch (error) {
    console.error("API request failed:", error)
    throw error
  }
}

export const endpoints = {
  weather: "/api/weather",
  crops: "/api/crops",
  suitableCrops: "/api/crops/suitable",
  cropRotation: "/api/crop-rotation",
  adminLogin: "/api/admin/login",
  adminRegister: "/api/admin/register",
  reports: "/api/reports",
  upload: "/api/upload",
  photos: "/api/photos",
  analytics: "/api/admin/analytics",
  cropGrowth: "/api/weather/crop-growth",
}
